/* Theme asset, NOT Customer Events. Uses Shopify privacy API and cart attributes.
   Creates no new cookies, localStorage or sessionStorage entries.
   Normal Online Store cart only; accelerated checkout must be verified separately. */
(() => {
  if (window.oaiSyncOrderContext) return;
  let chain = Promise.resolve();
  let pendingClick = new URL(location.href).searchParams.get('oppref') || '';
  let pendingClickAt = new Date().toISOString();
  const root = window.Shopify?.routes?.root || '/';
  const text = value => typeof value === 'string' ? value : '';
  function allowed() {
    const privacy = window.Shopify?.customerPrivacy;
    try {
      return privacy?.marketingAllowed() === true &&
        privacy.analyticsProcessingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch { return false; }
  }
  async function sync() {
    const permit = allowed();
    const response = await fetch(`${root}cart.js`, {credentials: 'same-origin', signal: AbortSignal.timeout(5000)});
    if (!response.ok) throw new Error('Cart read failed');
    const cart = await response.json();
    const old = cart.attributes || {};
    let click = '', capturedAt = '';
    if (permit) {
      const existing = text(old.oai_oppref);
      const age = Date.now() - Date.parse(old.oai_oppref_captured_at);
      if (existing && age >= 0 && age <= 30 * 86400000) {
        click = existing; capturedAt = old.oai_oppref_captured_at;
      }
      if (pendingClick && pendingClick.length <= 4096 && /^[A-Za-z0-9_-]+={0,2}$/.test(pendingClick)) {
        click = pendingClick; capturedAt = pendingClickAt;
      }
    } else {
      // Discard a denied journey's click, rather than resurrect it later.
      pendingClick = '';
    }
    const update = await fetch(`${root}cart/update.js`, {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: {
        oai_measurement_consent: permit ? 'granted' : 'denied',
        oai_measurement_checked_at: new Date().toISOString(),
        oai_oppref: click, oai_oppref_captured_at: capturedAt
      }}), signal: AbortSignal.timeout(5000)
    });
    if (!update.ok) throw new Error('Cart context update failed');
    if (permit) pendingClick = '';
    return {allowed: permit};
  }
  window.oaiSyncOrderContext = function () {
    chain = chain.catch(() => {}).then(sync);
    return chain;
  };
  // Await sync on ordinary cart checkout links/forms. Does not alter dynamic payment buttons.
  // Expose the same Promise for theme-specific JS checkout handlers.
  const bypassForms = new WeakSet();
  document.addEventListener('submit', event => {
    const form = event.target;
    const button = event.submitter;
    if (bypassForms.has(form)) { bypassForms.delete(form); return; }
    if (button?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void window.oaiSyncOrderContext().catch(() => {
      console.warn('[OpenAI] Pre-checkout context sync failed; order may be skipped');
    }).then(() => {
      bypassForms.add(form);
      form.requestSubmit(button);
    });
  }, true);
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.target && link.target !== '_self' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void window.oaiSyncOrderContext().catch(() => {
      console.warn('[OpenAI] Pre-checkout context sync failed; order may be skipped');
    }).then(() => location.assign(url.href));
  }, true);
  function refresh() {
    void window.oaiSyncOrderContext().catch(() => console.warn('[OpenAI] Cart context sync failed'));
  }
  document.addEventListener('visitorConsentCollected', refresh);
  window.addEventListener('pageshow', refresh);
  if (window.Shopify?.customerPrivacy) refresh();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
      if (!error) refresh();
      else console.warn('[OpenAI] Shopify privacy API unavailable');
    });
  }
})();
